"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _RequestStatusTypes = _interopRequireDefault(require("../constants/RequestStatusTypes"));

var _UIStickyFooter = _interopRequireDefault(require("UIComponents/panel/UIStickyFooter"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _MaybeRenderHOC = _interopRequireDefault(require("./hoc/MaybeRenderHOC"));

var _usageTracker = _interopRequireDefault(require("../utils/usageTracker"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var SettingsStickySaveFooter =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(SettingsStickySaveFooter, _PureComponent);

  function SettingsStickySaveFooter(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SettingsStickySaveFooter);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SettingsStickySaveFooter).call(this, props));
    _this.handleSave = _this.handleSave.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCancel = _this.handleCancel.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(SettingsStickySaveFooter, [{
    key: "handleSave",
    value: function handleSave() {
      var onSave = this.props.onSave;

      _usageTracker.default.track('sulSettingsSave');

      onSave();
    }
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      var onCancel = this.props.onCancel;

      _usageTracker.default.track('sulSettingsCancel');

      onCancel();
    }
  }, {
    key: "renderButtons",
    value: function renderButtons() {
      var _this$props = this.props,
          saveRequestStatus = _this$props.saveRequestStatus,
          saveDisabled = _this$props.saveDisabled,
          disabledTooltip = _this$props.disabledTooltip,
          disabledTooltipProps = _this$props.disabledTooltipProps;
      var disableButtons = saveRequestStatus === _RequestStatusTypes.default.PENDING;
      return _react.default.createElement("div", null, _react.default.createElement(_UITooltip.default, (0, _extends2.default)({
        disabled: !(saveDisabled && disabledTooltip),
        title: disabledTooltip
      }, disabledTooltipProps), _react.default.createElement(_UIButton.default, {
        use: "primary",
        disabled: disableButtons || saveDisabled,
        onClick: this.handleSave,
        "data-test-id": "save-footer-confirm-btn"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "settingsuilib.save"
      }))), _react.default.createElement(_UIButton.default, {
        use: "secondary",
        disabled: disableButtons,
        onClick: this.handleCancel,
        "data-test-id": "save-footer-cancel-btn"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "settingsuilib.cancel"
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          description = _this$props2.description,
          shouldRender = _this$props2.shouldRender;
      return _react.default.createElement(_MaybeRenderHOC.default, {
        shouldRender: shouldRender
      }, _react.default.createElement(_UIStickyFooter.default, {
        className: "save-sticky-footer",
        "data-test-id": "save-sticky-footer"
      }, _react.default.createElement(_UIFlex.default, {
        className: "container",
        align: "center",
        justify: "start",
        direction: "row",
        wrap: "nowrap"
      }, this.renderButtons(), _react.default.createElement("div", {
        className: "m-left-6",
        "data-test-id": "save-footer-description"
      }, description))));
    }
  }]);
  return SettingsStickySaveFooter;
}(_react.PureComponent);

SettingsStickySaveFooter.defaultProps = {
  disabledTooltipProps: {},
  saveRequestStatus: _RequestStatusTypes.default.UNINITIALIZED,
  saveDisabled: false
};
SettingsStickySaveFooter.propTypes = {
  description: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.node]),
  saveRequestStatus: _react.PropTypes.string,
  shouldRender: _react.PropTypes.bool.isRequired,
  onCancel: _react.PropTypes.func.isRequired,
  onSave: _react.PropTypes.func.isRequired,
  saveDisabled: _react.PropTypes.bool,
  disabledTooltip: _react.PropTypes.node,
  disabledTooltipProps: _react.PropTypes.object
};
var _default = SettingsStickySaveFooter;
exports.default = _default;
module.exports = exports.default;